<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Orders</h2>
    <div class="search-export pt-6">
      <div class="flex items-center">
        <div class="w-1/3 relative">
          <Search
            placeholder="SEARCH BY ORDER#, NAME"
            @input="updateSearchTerm"
            :searchOnSubmit="true"
          />
        </div>
        <div class="ml-auto">
          <button
            @click="exportOrders"
            :class="{ 'button-loading': exportingOrders }"
            :disabled="exportingOrders || !orders || !orders.length"
            class="whitebutton-gemnote button-gemnote-glass--tiny "
          >
            <span>Export </span>
          </button>
        </div>
      </div>
    </div>

    <div class="order-summary mt-4">
      <div class="flex mt-9  md:flex-row flex-col">
        <!-- <Skeleton v-if="!loadStatus" width="100%" height="10rem" /> -->

        <div class="card-holder md:w-1/2 w-full p-5 border-right-mobile">
          <div class="flex justify-between">
            <div>
              <div class="flex gap-x-2 flex-wrap items-center">
                <span class="font-bold">Total Fulfillment Fees</span>
                <span class="date-filter-info">
                  ({{
                    formatDateFilterRange(
                      dateRangeFilter.startDate,
                      dateRangeFilter.endDate
                    )
                  }})</span
                >
              </div>
            </div>
          </div>
          <div
            class="mt-2.5 text-left flex items-center gap-1"
            v-if="!loadStatus"
          >
            <Skeleton width="15%" height="2rem" style="margin-bottom: 0px;" />
            <Skeleton width="10%" height="2rem" style="margin-bottom: 0px;" />
          </div>
          <div v-else class="mt-2.5 text-left flex items-center gap-1">
            <span
              v-if="
                ordersPagination.metrics &&
                  ordersPagination.metrics.totalFulfillmentFees
              "
              class="text-2xl font-semibold value"
              >{{
                formatCurrency(ordersPagination.metrics.totalFulfillmentFees)
              }}</span
            >
            <span v-else class="text-2xl font-semibold value">{{
              formatCurrency(0)
            }}</span>
            <span class="text-xl font-light">USD</span>
          </div>
        </div>

        <!-- <Skeleton v-if="!loadStatus" width="100%" height="10rem" /> -->

        <div class="card-holder  p-5 md:w-1/2 w-full border-right">
          <div class="flex justify-between">
            <div>
              <div class="flex gap-x-2 flex-wrap items-center">
                <span class="font-bold">Total Shipping Fees</span>
                <span class="date-filter-info">
                  ({{
                    formatDateFilterRange(
                      dateRangeFilter.startDate,
                      dateRangeFilter.endDate
                    )
                  }})</span
                >
              </div>
            </div>
          </div>
          <div
            class="mt-2.5 text-left flex items-center gap-1"
            v-if="!loadStatus"
          >
            <Skeleton width="15%" height="2rem" style="margin-bottom: 0px;" />
            <Skeleton width="10%" height="2rem" style="margin-bottom: 0px;" />
          </div>
          <div v-else class="mt-2.5 text-left">
            <span class="text-2xl font-semibold value">
              <span
                v-if="
                  ordersPagination.metrics &&
                    ordersPagination.metrics.totalShippingFees
                "
                class="value"
                >{{
                  formatCurrency(ordersPagination.metrics.totalShippingFees)
                }}</span
              >
              <span v-else class="value">{{ formatCurrency(0) }}</span>
              <span class="text-xl font-light"> USD</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="filter flex mt-6">
      <div
        class="date-filter flex items-center justify-end gap-1 md:gap-4 ml-auto"
      >
        <div class="date-filter-title flex items-center gap-2">
          <img src="../../assets/filter-icon.svg" />
        </div>
        <div class="date-filter-calender flex items-center gap-0">
          <span class="font-normal text-sm">Date</span>
          <DateRangePicker
            :dateRange="dateRangeFilter"
            @update:dateRange="handleDateRangeUpdate"
            @onCancel="handleCancelFilter"
          />
        </div>
      </div>
    </div>

    <div class="mt-5">
      <vue-good-table
        :isLoading="!loadStatus"
        :columns="columns"
        :rows="orders"
        :styleClass="
          `vgt-table striped shopify-order-table ${
            !loadStatus ? 'vgt-table--loading' : ''
          }`
        "
        :totalRows="(ordersPagination && ordersPagination.totalCount) || 0"
        mode="remote"
        @on-page-change="handlePageChange"
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false
        }"
      >
        <template slot="loadingContent">
          <div class="">
            <Skeleton width="100%" height="3rem" v-for="i in 5" :key="i" />
          </div>
        </template>
        <template slot="table-row" slot-scope="orders">
          <span v-if="orders.column.field === 'orderDate'">
            <span>{{ formatShopifyDate(orders.row.orderDate) }}</span>
          </span>
          <span v-else-if="orders.column.field === 'trackingNumber'">
            <span
              v-if="orders.row.trackingNumber"
              class="underline cursor-pointer"
            >
              {{ orders.row.trackingNumber }}
            </span>
            <span v-else> Not available </span>
          </span>
        </template>

        <template slot="pagination-bottom">
          <Pagination
            v-show="loadStatus"
            :total-items="
              (ordersPagination && ordersPagination.totalCount) || 0
            "
            :page="serverParams.page - 1"
            :items-per-page="serverParams.perPage"
            @page-change="handlePageChange"
            @perPageChange="handlePerPageChange"
            perPageDropdownClasses="no-border"
          />
        </template>
      </vue-good-table>
    </div>
    <!-- Modal Here -->
    <ExportModal
      :showFooter="true"
      v-show="isExportModalActive"
      @hideModal="closeModal"
      :showCancelButton="false"
      @confirmAction="closeModal"
    >
      <template slot="header">
        <span>Exporting Orders</span>
      </template>

      <template slot="body">
        <span
          >We are exporting your order, we will send a link to
          <strong> {{ user.email }} </strong> when it’s done. Keep an eye on
          your inbox!
        </span>
      </template>
    </ExportModal>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { mapState } from 'vuex'
import Util from '../../mixins/Util'
import Skeleton from '../Universal/Skeleton'
import Pagination from '@/components/Universal/Pagination'
import Search from '@/components/Universal/Search'
import ExportModal from '@/components/Universal/ExportModal'
import DateRangePicker from '@/components/Universal/DateRangePicker'
import { progressStatus } from '@/helpers'
import DateFns from '@/mixins/DateFns'

export default {
  name: 'ShopifyOrders',
  mixins: [Util, DateFns],
  components: {
    ExportModal,
    VueGoodTable,
    Skeleton,
    Pagination,
    Search,
    DateRangePicker
  },
  data() {
    return {
      serverParams: {
        page: 1,
        perPage: 10,
        seachTerm: ''
      },
      dateFilters: [
        {
          label: 'Today',
          value: 'today'
        },
        {
          label: 'Yesterday',
          value: 'yesterday'
        },
        {
          label: 'Last 7 days',
          value: 'last_7'
        },
        {
          label: 'Last 30 days',
          value: 'last_30'
        },
        {
          label: 'All time',
          value: ''
        }
      ],
      // default date range is last 7 days
      dateRangeFilter: {
        startDate: this.formatToUTCMidnight(
          new Date(new Date().setDate(new Date().getDate() - 7))
        ),
        endDate: new Date(),
        range: 'Last 7 days'
      },
      dateFilter: 'Last 7 days',
      columns: [
        {
          label: 'Date',
          field: 'orderDate'
        },
        {
          label: 'Shopify Order #',
          field: 'shopifyOrderId',
          width: '150px'
        },
        {
          label: 'Name',
          field: 'orderRecipientName'
        },
        {
          label: 'Fulfillment  fee',
          field: 'fulfillmentFee',
          formatFn: this.formatCurrency,
          width: '140px'
        },
        {
          label: 'Shipping fee',
          field: 'shippingLabelFee',
          formatFn: this.formatCurrency,
          width: '140px',
          align: 'left'
        },
        {
          label: 'Status',
          field: 'orderStatus'
        },
        {
          label: 'Tracking',
          field: 'trackingNumber'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      loadingOrders: state => state.shopify.loadShopifyOrders,
      exportingOrders: state => state.ecommerce.exportingOrder,
      isExportModalActive: state => state.modal.isExportModalActive,
      user: state => state.profile.user,
      shopifyOrders: state => state.shopify.orders.data,
      ordersPagination: state => state.shopify.orders.meta || {},
      searchTerm: state => state.globalTracking.searchTerm
    }),
    orders() {
      if (this.shopifyOrders && this.shopifyOrders.length) {
        return this.shopifyOrders.map(order => ({
          ...order,
          ...order.attributes
        }))
      }
      return this.shopifyOrders || []
    },
    loadStatus() {
      return progressStatus(this.loadingOrders)
    }
  },
  created() {
    this.$store.dispatch('globalTracking/changeSearchTerm', '')
    this.getOrders()
  },
  methods: {
    updateSearchTerm(query) {
      this.serverParams.seachTerm = query
    },

    exportOrders() {
      this.$store.dispatch('modal/handleExports', 'shopify_orders')
    },
    handlePageChange(page) {
      this.serverParams.page = page + 1
      this.getOrders()
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getOrders()
    },
    convertDateFilterRange(date) {
      const d = new Date(date)
      return d.toISOString().split('T')[0]
    },
    getOrders() {
      this.$store.dispatch('shopify/getShopifyOrders', {
        page: this.serverParams.page,
        perPage: this.serverParams.perPage,
        startDate: this.convertDateFilterRange(this.dateRangeFilter.startDate),
        endDate: this.convertDateFilterRange(this.dateRangeFilter.endDate),
        filter: this.formatFilterTag(this.dateRangeFilter.range),
        search: this.searchTerm
      })
    },

    formatFilterTag(filter) {
      return filter.toLowerCase().replace(/\s+/g, '_')
    },
    closeModal() {
      this.$store.dispatch('modal/setExportModal', false)
    },
    handleCancelFilter() {
      this.dateRangeFilter = {
        ...this.dateRangeFilter
      }
    },
    handleDateRangeUpdate(params) {
      this.dateRangeFilter = {
        ...this.dateRangeFilter,
        ...params
      }
      this.getOrders()
    },
    formatShopifyDate(date) {
      return date.split(',')[0]
    }
  },

  watch: {
    async searchTerm(newVal) {
      this.serverParams.seachTerm = newVal
      await this.getOrders()
    }
  }
}
</script>

<style lang="scss" scoped>
.button-gemnote-glass--tiny {
  width: auto;
  height: 2.4rem;
  padding: 0 1.5rem !important;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

input {
  &::placeholder {
    color: #6c7a7b;
    font-size: 0.875rem;
  }
}

.border-2 {
  border: 1px solid #232220;
}

.border-l-2 {
  border-left: 1px solid #232220;
}

.value {
  color: #24292c;
  font-size: 1.375rem;
}

.date-filter {
  width: 100%;
}

.date-filter-title {
  span {
    font-size: 0.835rem;
    font-weight: 600;
  }
}

.date-filter-calender {
  cursor: pointer;
  border-bottom: 1px solid #25282a !important;
  span {
    font-size: 0.875rem;
    font-weight: 600;
  }
}

.date-filter-info {
  color: #232220;
  font-weight: 400;
  font-size: 13px;
}

.card-holder {
  height: 108px;
  max-height: 108px;
  border: 1px solid #232220;
  height: max-content;
  border-right: none;

  &.border-right {
    border-right: 1px solid #232220;
  }

  &.border-right-mobile {
    border-right: none;
  }

  @media (max-width: 768px) {
    &.border-right-mobile {
      border-right: 1px solid #232220;
      border-bottom: none;
    }
  }
  @media (min-width: 768px) {
    &.border-right-mobile {
      border-right: none;
      border-bottom: 1px solid #232220;
    }
  }
}
</style>
